import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { ErrorsPageComponent } from './components/errors-page/errors-page.component'

@NgModule({
  declarations: [
    ErrorsPageComponent,
    LandingPageComponent,
    SidenavComponent,
    ToolbarComponent,
    HomeComponent,
    PageNotFoundComponent,
    FooterComponent,
    
  ],
  imports: [SharedModule, RouterModule],
  exports: [SidenavComponent, ToolbarComponent, FooterComponent],
})
export class BaseModule {}
